<div class="dalel-404" dir="rtl">
  <p class="kicker">دليل بلس</p>
  <h1>الصفحة غير موجودة</h1>
  <p>عذرًا، لم نتمكن من العثور على الصفحة التي تبحث عنها.</p>
  <a routerLink="/home" class="btn">العودة للرئيسية</a>
</div>
